import React from 'react';

import FooterItem from './FooterItem';
import styles from './styles/footer.module.css';

import {ReactComponent as DfiniteLogoImg} from '../../assets/common/dfinite-logo.svg';

export default function Footer() {
    const infoMap = ['주식회사 디피니트', '대표 | 김도환', '사업자 등록번호 | 411-87-02664', '주소 | 서울시 마포구 서교동 475-1, 2층', '이메일 | dhkim@dfinite.ai'];
    const functionMap = ['채팅 기능', '관리자 기능'];
    const resouceMap = ['블로그', 'FAQ'];
    const serviceMap = ['개인정보처리방침', '서비스 이용약관'];

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <FooterItem 
                    type='dfinite'
                    Image={DfiniteLogoImg}
                    contentMap={infoMap}
                />
                <FooterItem   
                    title='주요 기능'
                    contentMap={functionMap}
                />
                <FooterItem 
                    title='리소스'
                    contentMap={resouceMap}
                />
                <FooterItem 
                    title='서비스 정책'
                    contentMap={serviceMap}
                />
            </div>
        </div>
    );
}
